import * as React from "react"
import { Skeleton } from "@mui/material"

import {WEBBACK_V2_API} from "@constants";
import { TitleWithPopover, AppTableSeeker } from "@components"
import {useToast, useUserApp} from "@hooks";
import { isLoadingCommonFilters } from "@signals"
import { useSellerDeepDiveTableDetails } from "../@hooks";
import { imageSkuColumn, priceColumn, skuColumn, retailerColumn, percentageColumn, avgPriceColumn, minPriceColumn, numCompetitorsColumn} from "./columns"
import CreateReportButton from "./actions/CreateReportButton";

export default function SellerDeepDiveTable() {
	const { showToast } = useToast()
	const { userUseRRSP, userCustomer } = useUserApp()
	// Luegopago (customer 13) wants the price dispersion colors swapped
	const invertPriceDispersionColors = userCustomer === 13
	const { tableData, isLoading } = useSellerDeepDiveTableDetails()
	
	if (isLoading) return <Skeleton variant="rectangular" height={500} />
	if (!tableData.data?.length) return <></>

    return <AppTableSeeker
		title={<TitleWithPopover title="Marketplaces - Seller deep dive" />}
		data={tableData.data}
		columns={[
			...retailerColumn(),
			imageSkuColumn(),
			skuColumn(),
			percentageColumn('discount', 'Discount'),
			priceColumn('actualPrice', 'Actual\nPrice', true),
			avgPriceColumn(),
			minPriceColumn(),
			numCompetitorsColumn(),
			priceColumn('shippingPrice', 'Shipping\nPrice'),
			...userUseRRSP ? [priceColumn('rrsp', 'RRSP')] : [],
			...userUseRRSP ? [percentageColumn('priceDispersion', 'Price dispersion\nvs RRSP', 2, invertPriceDispersionColors)] : []
		]}
		options={{
			onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/marketplaces/seller-deep-dive/excel`),
			customToolbar: () => <CreateReportButton />
		}}
	/>
}